import React from "react";
import Particles from "react-tsparticles";

/**
 * Particle config — "Deep Space" style
 * HOW TO CUSTOMIZE:
 * → Fewer particles: lower number.value (currently 60)
 * → Faster: increase move.speed
 * → More connections: increase line_linked.opacity
 * → Different color: change particles.color.value
 */
function Particle() {
  return (
    <Particles
      id="tsparticles"
      params={{
        particles: {
          number: {
            value: 60,
            density: { enable: true, value_area: 1200 },
          },
          color: { value: ["#b44fff", "#00d4ff", "#7b2fd4"] },
          shape: { type: "circle" },
          opacity: {
            value: 0.4,
            random: true,
            anim: { enable: true, speed: 0.6, opacity_min: 0.05, sync: false },
          },
          size: {
            value: 1.5,
            random: true,
          },
          line_linked: {
            enable: true,
            distance: 160,
            color: "#b44fff",
            opacity: 0.08,
            width: 1,
          },
          move: {
            enable: true,
            speed: 0.4,
            direction: "none",
            random: true,
            straight: false,
            out_mode: "out",
            bounce: false,
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: true, mode: "grab" },
            onclick: { enable: true, mode: "push" },
            resize: true,
          },
          modes: {
            grab: { distance: 140, line_linked: { opacity: 0.25 } },
            push: { particles_nb: 2 },
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;